import React from 'react';
import ServiceDetails from "../Components/ServiceDetails/ServiceDetails";
import FacadeImg from "../Assests/Images/carousal-facade.jpg"

export default function ServiceFacade() {
    return (
        <>
            <ServiceDetails
                ServiceName={"Facade / Glass Cleaning"}
                Description={"Transform the face of your business with our top-tier facade and glass cleaning services. At SaafSafaiWale, we understand that first impressions matter, and your building's exterior is the first thing your customers see. Our expert team is dedicated to ensuring your business shines brightly, literally and figuratively. With our professional equipments and eco-friendly cleaning solutions, we not only remove dirt, grime, and streaks from your windows and facade but also enhance the overall aesthetic appeal. A sparkling, well-maintained exterior not only enhances your brand image but also creates a welcoming atmosphere for your customers. Choose SaafSafaiWale for a cleaner, brighter, and more inviting look for your business. Let us make your facade and glass surfaces reflect the excellence of your services."}
                ServiceImage={<img src={FacadeImg} alt='Facade Cleaning'></img>} />

        </>
    )
}